import React from "react";
import history from "@dhn/shared/history";
import createApolloClient from "@dhn/shared/apollo-client";
import AppProvider from "@dhn/components/contexts/app-context";
import { Switch } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { ApolloProvider } from "@apollo/react-hooks";
import { useAuth0 } from "@dhn/components/contexts/react-auth0-spa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "./styles/tailwind.css";
import { Router } from "react-router-dom/cjs/react-router-dom.min";
import { ConfirmProvider } from "./@dhn/components/contexts/ConfirmProvider/ConfirmProvider";
import LoadingDhn from "./@dhn/components/Loading/LoadingDhn";
import RouteChangeLoading, {
  SuspenseLoadingFallback,
} from "./@dhn/components/Loading/RouteChangeLoading";
import useAppRouteData from "./hooks/useAppRouteData.js";
import MedicalPreregistrationPage from "./public-pages/MedicalPreregistrationPage";

function AppRoute({ loading, user }) {
  const { appLoading, canRender, providerValue, routes } = useAppRouteData({
    loading,
    user,
  });

  return (
    <div>
      {appLoading && (
        <LoadingDhn isOpen={true} isDescription={false} />
      )}
      {canRender && (
        <AppProvider value={providerValue}>
          <ToastProvider>
            <ConfirmProvider>
              <Router history={history}>
                <RouteChangeLoading />
                <React.Suspense fallback={<SuspenseLoadingFallback />}>
                  <Switch>{routes}</Switch>
                </React.Suspense>
              </Router>
            </ConfirmProvider>
          </ToastProvider>
        </AppProvider>
      )}
    </div>
  );
}

export default function App() {
  const { loading, user, redirectToLogin, getTokenSilently } = useAuth0();

  const path = window?.location?.pathname || "";
  if (path === "/registro-medico" || path.startsWith("/registro-medico/")) {
    return (
      <ToastProvider>
        <MedicalPreregistrationPage />
      </ToastProvider>
    );
  }

  const apolloClient = createApolloClient({
    redirectToLogin,
    getTokenSilently,
    uri: process.env.REACT_APP_APOLLO_CLIENT_URI,
  });

  return (
    <ApolloProvider client={apolloClient}>
      <AppRoute loading={loading} user={user} />
    </ApolloProvider>
  );
}
